import { FC } from "react";

import { Campaign } from "@vviinn/user-managment-client-ts";

import { ReferenceCatalogAcceptableRow } from "./ReferenceCatalogAcceptableRow";
import { ColorAcceptableRow } from "./ColorAcceptableRow";

import { Fields } from "../../../ui/layout/detailedPages/Fields";
import { UpdateCampaignProps } from "../types";
export const VPDAdvanced: FC<UpdateCampaignProps> = ({
  campaign,
  updateCampaignBody,
}) => {
  const handleReferenceCatalogChange = async (
    referenceSiteId: Campaign["referenceSiteId"],
    referenceCompanyId: Campaign["referenceCompanyId"] = "",
  ) =>
    updateCampaignBody(
      {
        referenceCompanyId,
        referenceSiteId,
      },
      "reference catalog",
    );

  return (
    <Fields title="Advanced settings">
      <ReferenceCatalogAcceptableRow
        campaign={campaign}
        onAccept={handleReferenceCatalogChange}
      />

      <ColorAcceptableRow
        campaign={campaign}
        updateCampaignBody={updateCampaignBody}
      />
    </Fields>
  );
};
